<div class="container-fluid" id="header" style="padding-top: 6%;">
  <div class="container p-0">
    <div class="row text-white my-10" >
      <div class="col-7 mt-5 p-0">
        <h1 class="font-brand mt-4 text-uppercase">Estructuramos tus ideas en proyectos de software para hacerlas realidad.</h1>
        <p class="font-brand-secondary text-uppercase" style="font-size: 15px;">Si lo imaginaste, podemos programarlo.</p>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-6 offset-1 p-0">
      <img src="../../../../../assets/backgrounds/bg0.svg" alt="" class="img-fluid">
    </div>
  </div>
  <ng-lottie
    id="animation"
    style="position: absolute; top: 0; z-index: 1030; left: 150px;" 
    [options]="options" 
    (animationCreated)="animationCreated($event)" 
    [styles]="styles"
  ></ng-lottie>
</div>